import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { DecideResourceApprovalRequest } from './interfaces';
import { falconClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';
import { baseUrl } from '@/data/subsidy/base';

export const useDecideResourceApproval = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      decision,
      decision_comment,
      resource_approval_uuid,
    }: DecideResourceApprovalRequest) => {
      return falconClient.patch(
        `${baseUrl}/resource_approvals/${resource_approval_uuid}/decision`,
        { resource: { decision, reason: decision_comment } }
      );
    },
    onSuccess: async () => {
      queryClient.refetchQueries({
        queryKey: [clientKeys.useResourceApprovalDetails],
      });
      queryClient.refetchQueries({
        queryKey: [clientKeys.useResourceApprovalsToReview],
        type: 'all',
      });
    },
  });
};
